<h1>Top {{mode() === 'albums' ? 'Albums' : 'Artists'}}</h1>
<h3>The most popular {{mode() === 'albums' ? 'albums' : 'artists'}} on Deezer right now.
  Click {{mode() === 'albums' ? 'the album cover or artist name' : 'an artist'}} for more information.</h3>

<div class="filters">
  <div class="chip-row" role="group" aria-label="Browse">
    <button type="button" class="filter-chip" [class.active]="mode() === 'albums'"
      [attr.aria-pressed]="mode() === 'albums'" (click)="setMode('albums')">Albums</button>
    <button type="button" class="filter-chip" [class.active]="mode() === 'artists'"
      [attr.aria-pressed]="mode() === 'artists'" (click)="setMode('artists')">Artists</button>
  </div>

  <div class="chip-row" role="group" aria-label="Genre">
    @for (g of genres(); track g.id) {
    <button type="button" class="filter-chip"
      [class.active]="g.id === selectedGenre() && !curatedKey()"
      [attr.aria-pressed]="g.id === selectedGenre() && !curatedKey()" (click)="selectGenre(g.id)">{{g.name}}</button>
    }
  </div>

  @if (mode() === 'albums' && subgenreOptions().length > 0 && (!curatedKey() || subgenre())) {
  <div class="chip-row sub-row" role="group" aria-label="Sub-genre">
    <span class="status">Sub-genre:</span>
    @for (s of subgenreOptions(); track s.key) {
    <button type="button" class="filter-chip small" [class.active]="s.key === subgenre()"
      [attr.aria-pressed]="s.key === subgenre()" (click)="selectSubgenre(s.key)">{{s.label}}</button>
    }
  </div>
  }

  @if (mode() === 'albums') {
  <div class="chip-row control-row">
    <label class="control">
      <span>Language</span>
      <select (change)="selectLanguage($any($event.target).value)">
        <option value="" [selected]="!language()">All languages</option>
        @for (l of options().languages; track l.key) {
        <option [value]="l.key" [selected]="l.key === language()">{{l.label}}</option>
        }
      </select>
    </label>
    <label class="control">
      <span>Mood</span>
      <select (change)="selectMood($any($event.target).value)">
        <option value="" [selected]="!mood()">Any mood</option>
        @for (m of options().moods; track m.key) {
        <option [value]="m.key" [selected]="m.key === mood()">{{m.label}}</option>
        }
      </select>
    </label>
    <label class="control">
      <span>Decade</span>
      <select (change)="selectDecade($any($event.target).value)">
        <option value="" [selected]="!decade()">Any decade</option>
        @for (d of options().decades; track d.key) {
        <option [value]="d.key" [selected]="d.key === decade()">{{d.label}}</option>
        }
      </select>
    </label>
    <app-album-sort-controls [sort]="sort()" [year]="year()" [years]="years" [availableYears]="availableYears()"
      (sortChange)="setSort($event)" (yearChange)="setYear($event)" />
    @if (datesLoading()) {
    <span class="status">Loading release dates&hellip;</span>
    }
  </div>
  @if (curatedKey()) {
  <p class="status">Language, mood, decade and sub-genre lists are curated from Deezer playlists, so they are a guide rather than a complete catalogue.</p>
  }
  }
</div>

@if (error()) {
<p class="status error">{{error()}}</p>
}

<div class="container">
  @if (mode() === 'albums') {
  <app-album-grid [albums]="visible()" [favouriteIds]="favourites.ids()" (favouriteToggle)="toggleFavourite($event)" />
  } @else {
  <app-artist-grid [artists]="visible()" [favouriteIds]="artistFavourites.ids()" (favouriteToggle)="toggleFavouriteArtist($event)" />
  }

  @if (!loading() && !datesLoading() && visible().length === 0 && !error()) {
  <p class="status">Nothing to show{{year() ? ' for ' + year() : ''}}.</p>
  }

  <app-pager [page]="page()" [pages]="pages()" (pageChange)="setPage($event)" />
  @if (filtered().length > 0) {
  <p class="status count">{{filtered().length}} {{mode() === 'albums' ? 'albums' : 'artists'}} &middot; page {{page()}} of {{pages()}}</p>
  }
</div>
